export default {
  noRank: "–"
};
